export default {"src":"/_next/static/media/bdl.f4879b4f.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};